import React from "react";
import NotificationAlert from "react-notification-alert";
import { connect } from 'react-redux';
import {
  Container, Row, Col,
  Card, CardHeader, CardBody,
  Input, Button, Collapse, FormGroup, CustomInput,
  Badge, Modal, ModalHeader, ModalBody, ModalFooter,
  UncontrolledTooltip
} from "reactstrap";
import { ClipLoader } from 'react-spinners';
import api from "./../../Api.js";
import SimpleHeader from "./../../components/Headers/SimpleHeader.jsx";
import debounce from "lodash/debounce";

class ClassRoom extends React.Component {
  constructor(props) {
    super(props);
    this.notificationAlertRef = React.createRef();
    this.state = {
      companies: [],
      classroomsByCompany: {},
      expanded: [],
      loadingCompany: {},
      searchTerm: "",
      selected: [],
      unitSearch: {},
      modalOpen: false,
      loadReq: false
    };
    this.loadCompanies();
    this.loadCompanyClassroomsDebounced = debounce(this.loadCompanyClassrooms, 300);
    this.handleUnitSearch = this.handleUnitSearch.bind(this);
    this.selectAllUnit = this.selectAllUnit.bind(this);
    this.clearAllUnit = this.clearAllUnit.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  async loadCompanies() {
    try {
      const res = await api.getListCompany();
      this.setState({ companies: res.data });
    } catch (err) {
      console.error(err);
    }
  }

  loadCompanyClassrooms = async companyId => {
    this.setState(s => ({
      loadingCompany: { ...s.loadingCompany, [companyId]: true }
    }));
    try {
      const res = await api.getAllClassRoomCompany(companyId);
      this.setState(s => ({
        classroomsByCompany: {
          ...s.classroomsByCompany,
          [companyId]: res.data
        }
      }));
    } catch (err) {
      console.error(err);
    }
    this.setState(s => ({
      loadingCompany: { ...s.loadingCompany, [companyId]: false }
    }));
  }

  toggleCompany = companyId => {
    this.setState(s => {
      const isOpen = s.expanded.includes(companyId);
      const expanded = isOpen
        ? s.expanded.filter(id => id !== companyId)
        : [...s.expanded, companyId];
      if (!isOpen && !s.classroomsByCompany[companyId]) {
        this.loadCompanyClassroomsDebounced(companyId);
      }
      return { expanded };
    });
  }

  handleSearch = e => {
    this.setState({ searchTerm: e.target.value });
  }

  handleUnitSearch(companyId, e) {
    const value = e.target.value;
    this.setState(s => ({
      unitSearch: { ...s.unitSearch, [companyId]: value }
    }));
  }

  selectAllUnit(companyId) {
    const list = this.state.classroomsByCompany[companyId] || [];
    const ids = list.map(r => r.id);
    this.setState(s => ({
      selected: Array.from(new Set([...s.selected, ...ids]))
    }));
  }

  clearAllUnit(companyId) {
    const list = this.state.classroomsByCompany[companyId] || [];
    const ids = list.map(r => r.id);
    this.setState(s => ({
      selected: s.selected.filter(id => !ids.includes(id))
    }));
  }

  toggleModal() {
    this.setState(s => ({ modalOpen: !s.modalOpen }));
  }

  postClassRoom = async () => {
    await this.setState({ loadReq: true });

    try {
      const res = await api.generateGrandProgress({ classroom: this.state.selected });
      this.setState({ loadReq: false });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Relatório.xlsx');
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      this.setState({ loadReq: false });
      const options = {
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">Ops!</span>
            <span data-notify="message">{error.response?.data?.msg}</span>
          </div>
        ),
        type: 'danger',
        icon: "fas fa-exclamation",
        autoDismiss: 7
      };
      this.notificationAlertRef.current.notificationAlert(options);
    }
  }

  render() {
    const { companies, expanded, classroomsByCompany, loadingCompany, searchTerm, selected, unitSearch, modalOpen } = this.state;
    const term = searchTerm.toLowerCase();
    const roomsList = Object.values(classroomsByCompany).flat();

    return (
      <React.Fragment>
        <div className="rna-wrapper">
          <NotificationAlert ref={this.notificationAlertRef} />
        </div>
        <SimpleHeader
          name={this.props.translate['relatorio_turmas']}
          way={[
            { name: this.props.translate['usuarios'], url: "/users" },
            { name: this.props.translate['relatorio_turmas'], url: "/report/classroom" }
          ]}
        />
        
        <Container fluid className="mt--4" >
          <Card className="bg-white shadow" style={{ minHeight: 'calc(100vh - 100px)', borderRadius: 10 }}>

            <CardHeader className="border-0">
              <Row className="align-items-center">
                <Col xs="6">
                  <h3 className="mb-0">{this.props.translate['relatorio_turmas']}</h3>
                </Col>
                <Col xs="6" className="text-right">
                  <Input
                    bsSize="sm"
                    placeholder="Procurar empresa ou turma…"
                    value={searchTerm}
                    onChange={this.handleSearch}
                    style={{ maxWidth: '200px', display: 'inline-block' }}
                  />
                </Col>
              </Row>
            </CardHeader>

            <CardBody className="px-4 py-3" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Row className="justify-content-center" style={{ flex: '0 0 auto' }}>
                <Col lg="10">
                  {companies.map(c => {
                    const list = classroomsByCompany[c.id] || [];
                    const matchesCompany = c.name.toLowerCase().includes(term);
                    const matchesSomeRoom = list.some(r =>
                      r.name.toLowerCase().includes(term)
                    );
                    if (term && !matchesCompany && !matchesSomeRoom) return null;
                    const isOpen = expanded.includes(c.id);
                    const uTerm = (unitSearch[c.id] || "").toLowerCase();
                    const filtered = uTerm
                      ? list.filter(r => r.name.toLowerCase().includes(uTerm))
                      : list;
                    const loaded = !!classroomsByCompany[c.id] && !loadingCompany[c.id];

                    return (
                      <Card key={c.id} className="mb-2 shadow-sm">
                        <CardHeader
                          onClick={() => this.toggleCompany(c.id)}
                          style={{ cursor: "pointer" }}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <span>{c.name}</span>
                          <div className="d-flex align-items-center">
                            <Button
                              size="sm"
                              color="primary"
                              disabled={!loaded}
                              onClick={e => {
                                e.stopPropagation();
                                this.selectAllUnit(c.id);
                              }}
                            >
                              Marcar todos
                            </Button>
                            <Button
                              size="sm"
                              color="secondary"
                              className="ml-2"
                              disabled={!loaded}
                              onClick={e => {
                                e.stopPropagation();
                                this.clearAllUnit(c.id);
                              }}
                            >
                              Limpar todos
                            </Button>

                            { !loaded && (
                              <>
                                <span
                                  id={`tooltip-unloaded-${c.id}`}
                                  style={{ marginLeft: 8, cursor: "pointer" }}
                                >
                                  <i className="fas fa-exclamation-triangle text-warning" />
                                </span>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`tooltip-unloaded-${c.id}`}
                                  tooltipClassName="bg-warning text-dark"
                                  fade={false}
                                >
                                  Marcar/Limpar todos habilitado após carregar turmas.
                                </UncontrolledTooltip>
                              </>
                            )}
                          </div>
                        </CardHeader>
                        <Collapse isOpen={isOpen}>
                          <CardBody>
                            <Input
                              bsSize="sm"
                              placeholder="Pesquisar turma…"
                              value={unitSearch[c.id] || ""}
                              onChange={e => this.handleUnitSearch(c.id, e)}
                              className="mb-2"
                            />
                            {loadingCompany[c.id] ? (
                              <div className="w-100 text-center py-3">
                                <ClipLoader size={30} />
                              </div>
                            ) : (
                              <div style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto', padding: '8px' }}>
                                {filtered.length > 0 ? (
                                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px' }}>
                                    {filtered.map(r => {
                                      const isSel = selected.includes(r.id);
                                      return (
                                        <div
                                          key={r.id}
                                          role="button"
                                          tabIndex={0}
                                          onKeyPress={e => { if (e.key === 'Enter' || e.key === ' ') { const sel = isSel ? selected.filter(x => x !== r.id) : [...selected, r.id]; this.setState({ selected: sel }); } }}
                                          onClick={() => { const sel = isSel ? selected.filter(x => x !== r.id) : [...selected, r.id]; this.setState({ selected: sel }); }}
                                          style={{
                                            padding: '12px',
                                            border: isSel ? '2px solid #4e73df' : '1px solid #eef2f7',
                                            borderRadius: 8,
                                            background: isSel ? '#f4f8ff' : '#fff',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            minHeight: 64
                                          }}
                                        >
                                          <FormGroup check style={{ marginBottom: 0, marginRight: 8 }}>
                                            <CustomInput
                                              type="checkbox"
                                              id={`room-${r.id}`}
                                              checked={isSel}
                                              onChange={e => {
                                                e.stopPropagation();
                                                const sel = isSel ? selected.filter(x => x !== r.id) : [...selected, r.id];
                                                this.setState({ selected: sel });
                                              }}
                                            />
                                          </FormGroup>
                                          <div style={{ flex: 1, fontSize: '0.95rem', lineHeight: '1.15' }}>{r.name}</div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                ) : (
                                  <div>
                                    <p className="text-muted mb-0">Nenhuma turma encontrada.</p>
                                  </div>
                                )}
                              </div>
                            )}
                          </CardBody>
                        </Collapse>
                      </Card>
                    );
                  })}

                  {selected.length > 0 && (
                    <div
                      style={{
                        position: 'fixed',
                        bottom: '70px',           
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#fff',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        fontSize: '14px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        zIndex: 1050
                      }}
                    >
                      <small className="text-muted">Selecionadas:</small>
                      <div className="mt-1">
                        {selected.slice(0,5).map(id => {
                          const room = roomsList.find(r => r.id === id);
                          return room ? (
                            <div
                              key={id}
                              style={{
                                display: 'inline-block',
                                position: 'relative',
                                margin: '0 4px 4px 0'
                              }}
                              onMouseEnter={e => {
                                const close = e.currentTarget.querySelector('.close-icon');
                                if (close) close.style.display = 'block';
                              }}
                              onMouseLeave={e => {
                                const close = e.currentTarget.querySelector('.close-icon');
                                if (close) close.style.display = 'none';
                              }}
                            >
                              <Badge color="primary" pill>
                                {room.name}
                              </Badge>
                              <span
                                className="close-icon"
                                style={{
                                  position: 'absolute',
                                  top: '-4px',
                                  right: '-4px',
                                  background: '#fff',
                                  borderRadius: '50%',
                                  padding: '0 4px',
                                  cursor: 'pointer',
                                  fontSize: '0.75rem',
                                  lineHeight: 1,
                                  display: 'none'
                                }}
                                onClick={() =>
                                  this.setState(s => ({
                                    selected: s.selected.filter(x => x !== id)
                                  }))
                                }
                              >
                                ×
                              </span>
                            </div>
                          ) : null;
                        })}
                        {selected.length > 5 && (
                          <Badge
                            color="secondary"
                            pill
                            style={{ cursor: 'pointer' }}
                            onClick={this.toggleModal}
                          >
                            Ver mais (+{selected.length - 5})
                          </Badge>
                        )}
                      </div>
                    </div>
                  )}

                  {selected.length > 0 && (
                    <div
                      style={{
                        position: 'fixed',
                        bottom: '20px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1050,
                      }}
                    >
                          <Button color="primary" onClick={this.postClassRoom} disabled={this.state.loadReq}>
                            {this.state.loadReq ? (
                              <>
                                <ClipLoader size={16} color="#fff" />
                                <span className="ml-2">Gerando...</span>
                              </>
                            ) : (
                              <>
                                <i className="far fa-file-excel mr-1" />
                                {this.props.translate['gerar_planilha']}
                              </>
                            )}
                          </Button>
                    </div>
                  )}

                  <Modal isOpen={modalOpen} toggle={this.toggleModal} centered size="lg">
                    <ModalHeader toggle={this.toggleModal}>
                      Turmas selecionadas ({selected.length})
                    </ModalHeader>
                    <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                      {companies.map(c => {
                        const rooms = classroomsByCompany[c.id] || []
                        const selRooms = rooms.filter(r => selected.includes(r.id))
                        if (!selRooms.length) return null

                        return (
                          <div key={c.id} className="mb-3">
                            <h6 className="font-weight-bold">{c.name}</h6>
                            <div>
                              {selRooms.map(r => (
                                <div
                                  key={r.id}
                                  style={{
                                    display: 'inline-block',
                                    position: 'relative',
                                    margin: '0 4px 4px 0'
                                  }}
                                  onMouseEnter={e => {
                                    const close = e.currentTarget.querySelector('.close-icon')
                                    if (close) close.style.display = 'block'
                                  }}
                                  onMouseLeave={e => {
                                    const close = e.currentTarget.querySelector('.close-icon')
                                    if (close) close.style.display = 'none'
                                  }}
                                >
                                  <Badge color="primary" pill>
                                    {r.name}
                                  </Badge>
                                  <span
                                    className="close-icon"
                                    style={{
                                      position: 'absolute',
                                      top: '-4px',
                                      right: '-4px',
                                      background: '#fff',
                                      borderRadius: '50%',
                                      padding: '0 4px',
                                      cursor: 'pointer',
                                      fontSize: '0.75rem',
                                      lineHeight: 1,
                                      display: 'none'
                                    }}
                                    onClick={() =>
                                      this.setState(s => ({
                                        selected: s.selected.filter(id => id !== r.id)
                                      }))
                                    }
                                  >
                                    ×
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )
                      })}
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" onClick={this.toggleModal}>
                        Fechar
                      </Button>
                    </ModalFooter>
                  </Modal>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  translate: state.translate,
  user: state.user
}))(ClassRoom);